import React, { useState, useEffect } from "react";
import '../css/detail.css';
import { Link, useParams } from "react-router-dom";
import jsonData from '../data/detail.json';

export default function DetailTesti() {
    const { id } = useParams();
    const [testimonialIndex, setTestimonialIndex] = useState(parseInt(id) || 0);
    const [testimonial, setTestimonial] = useState(null);

    useEffect(() => {
        const selectedTestimonial = jsonData[testimonialIndex];
        setTestimonial(selectedTestimonial);
    }, [testimonialIndex]);

    const handleNextTestimonial = () => {
        setTestimonialIndex(prevIndex => (prevIndex + 1) % jsonData.length);
    };

    return (
        <section>
            <img src="../../assets/testi/detail.svg" className="hero-testi" alt="Testimonials Hero"></img>
            <h1 className="detail-testi mx-auto">TESTIMONI</h1>
            <div className="konten-detail">
                <Link to="/" className="beranda">👈 Kembali ke beranda</Link>
                {testimonial && (
                    <div>
                        <div className="judul-testi d-flex justify-content-between align-items-start">
                            <h1>Cerita mereka tentang SMA Lab UM</h1>
                            <div className="nomorSlide">
                                {testimonial.nomor} <span> / 04</span>
                            </div>
                        </div>
                        <div className="text-detail">
                            <h1 className="komentar" style={{ textDecoration: "none", color: "black" }}>{testimonial.komentar}</h1>
                            <div className="komentator d-flex align-items-start gap-3">
                                <img src={testimonial.foto} alt="Profile" className="p-testi" />
                                <div>
                                    <h1 className="nama nama-testi">{testimonial.nama}</h1>
                                    <p className="dari">Wali dari <span className="wali wali-testi">{testimonial.wali}</span>/ {testimonial.kls}</p>
                                </div>
                            </div>
                        </div>
                        <div className="akhir-testi d-flex justify-content-between align-items-start" style={{cursor: "pointer"}} onClick={handleNextTestimonial}>
                            <p>Selanjutnya</p>
                            <img src="../../assets/hero/right.svg"></img>
                        </div>

                    </div>
                )}
            </div>
        </section>
    )
}
